<div class="container">
    <div class="card" style="position: relative;">
        <div>
            <h2>Charge files</h2> 
            <p style="font-size: 14px;">NB: Only files extention(s) {{acceptedExtensionsString}} will be accepted and limited to 100M</p>
        </div>
        <div style="padding-top: 0px;">
            <div class="row" style="justify-content: center;">
                <div>
                    <div>
                        <div style="margin: 8px; display: flex; height: 20px;">
                            <div style="width: 90%; font-size : 16px"><span class="text-success">{{successMessage}}</span> <span class="text-warning">{{warningMessage}}</span> <span class="text-danger">{{errorMessage}}</span></div>
                            <div style="width: 10%;">
                                <mat-icon class='bx bx-menu' style="color: var(--primary); float: right; padding-right: 30px; cursor: pointer;" aria-hidden="false" fontIcon="update" title="Reset" (click)="resetUpload()"></mat-icon>
                            </div>
                        </div>
                    </div>
                    <div class="drag_drop">
                        <input type="file" id="select_files" class="file_erea" accept="{{acceptedExtensionsString}}" (change)="onFileSelected($event)" (drop)="onFileDroped($event)" multiple="multiple" hidden>
                        <label for="select_files" id="select_label" style=" background-color: #f9f9f9; cursor: pointer; color: black; width: 100%; height:100%;">Select or Drag and drop files here</label>
                    </div>
                </div>
                <button class="button-secondary-small" style="margin-top: 10px;" (click) = "checkUploadFiles()">Upload Contents</button>
            </div>
        </div>
    </div>
</div>
<div *ngIf="['vca', 'vcl'].includes(this.platformInfos.key)">
    <div fxLayout="row" style="padding: 20px 10px 20px 10px;">
        <div class="center-vertical" fxFlex="60%">
            <p>Total: {{this.showedRows.length}} sur {{totalRows}}</p>
        </div>
        <div fxLayout="row" class="center-vertical" fxFlex="40" style="display: flex; align-items: center;">
            <div style="margin-left: auto;" fxFlex="80">
                <input class="col-input" [formControl]="searchContentControl" placeholder="Search">
            </div>
            <div class="class-mat-field" fxFlex="20"  fxLayoutAlign="center center">
                <button class="button-secondary-small" (click) = "loadExistingData()">Load</button>
            </div>
        </div>
    </div>
    <div class="table_div" style="height: 400px;">
        <div class="nav-preview" fxLayout="row" fxLayoutAlign="center center" style="float: bottom; position: absolute;">
            <mat-icon [ngClass]="navIndex === 0 ? 'nav-inactive' : 'nav-active'"style="padding: 0px 14px 0px 0px; font-size: 40px; height: 40px;" fontIcon="arrow_left" title="Previous" (click)="movePrevNextNavigation('prev')"></mat-icon>
            <span style="font-weight: bold;"> Nav {{ navIndex *  this.filterData.limit}} / {{ totalRows}}</span>
            <mat-icon [ngClass]="navIndex === totalNavigations - 1 ? 'nav-inactive' : 'nav-active'" style="padding-right: 10px; font-size: 40px; height: 40px;" fontIcon="arrow_right" title="Next" (click)="movePrevNextNavigation('next')"></mat-icon>
        </div>
        <table>
            <thead>
                <tr>
                    <th>
                        <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'id_content', 'number')"></mat-icon>
                        <div class="column-name">Id Content</div>
                        <div><input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'id_content')"></div>
                    </th>
                    <th>
                        <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'parent', 'string')"></mat-icon>
                        <div class="column-name">Parent</div>
                        <div><input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'parent')"></div>
                    </th>
                    <th>
                        <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'module', 'string')"></mat-icon>
                        <div class="column-name">Module</div>
                        <div><input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'module')"></div>
                    </th>
                    <th>
                        <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'details', 'string')"></mat-icon>
                        <div class="column-name">Details</div>
                        <div><input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'details')"></div>
                    </th>
                    <th>
                        <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'content_name', 'string')"></mat-icon>
                        <div class="column-name">Content Name</div>
                        <div><input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'content_name')"></div>
                    </th>
                    <th>
                        <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'active', 'boolean')"></mat-icon>
                    <div class="column-name">Active</div>
                        <mat-select placeholder="Choose" style="height: 22px;" (selectionChange)="applyFilterLocal($event, 'active')">
                            <mat-option [value]="''">ALL</mat-option>
                            <mat-option [value]="'false'">False</mat-option>
                            <mat-option [value]="'true'">True</mat-option>
                        </mat-select>
                    </th>
                    <th>
                        <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'source', 'string')"></mat-icon>
                        <div class="column-name">Source</div>
                        <mat-select placeholder="Choose" style="height: 22px;" (selectionChange)="applyFilterLocal($event, 'source')">
                            <mat-option [value]="''">ALL</mat-option>
                            <mat-option [value]="'uploaded'">Uploaded</mat-option>
                            <mat-option [value]="'raw'">Raw</mat-option>
                            <mat-option [value]="'project'">Project</mat-option>
                            <mat-option [value]="'content'">Content</mat-option>
                        </mat-select>
                    </th>
                </tr>
            </thead>
            <tbody #row_tbody *ngFor="let row of showedRows; let i = index">
                <tr (click)="toggleRow(row, $event.target, row_tbody)">
                    <td>{{ row['id_content'] }}</td>
                    <td matTooltip="{{ row['parent'] }}" matTooltipPosition="below" matTooltipTouchGestures="off">{{ row['parent'] }}</td>
                    <td matTooltip="{{ row['module'] }}" matTooltipPosition="below" matTooltipTouchGestures="off">{{ row['module'] }}</td>
                    <td matTooltip="{{ row['details'] }}" matTooltipPosition="below" matTooltipTouchGestures="off">{{ row['details'] }}</td>
                    <td matTooltip="{{ row['content_name'] }}" matTooltipPosition="below" matTooltipTouchGestures="off">{{ row['content_name'] }}</td>
                    
                    <td>{{ row['active'] }}</td>
                    <td>{{ row['source'] }}</td>
                </tr>
                <tr class="expand_detail" *ngIf="row['expanded']">
                    <td colspan="13">
                        <app-pdf-viewer [userInfos]="userInfos" [pdfData]="row['pdf_data']" class="pdf-container"></app-pdf-viewer>
                    </td>
                </tr>
            </tbody>
            <tbody *ngIf="showedRows.length === 0">
                <tr ><td colspan="14" style="text-align: center;">No matching records found</td></tr>
            </tbody>
        </table>
    </div>
</div>